// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .MuiCheckbox-colorPrimary {
  color: transparent !important;
} */
.MuiCheckbox-colorPrimary:hover {
  color: #0e0a4266 !important;
}
.Mui-checked {
  color: #0e0a42 !important;
}
.Mui-checked:hover {
  color: #0e0a42 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/AuditPlanForm3/styles.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["/* .MuiCheckbox-colorPrimary {\n  color: transparent !important;\n} */\n.MuiCheckbox-colorPrimary:hover {\n  color: #0e0a4266 !important;\n}\n.Mui-checked {\n  color: #0e0a42 !important;\n}\n.Mui-checked:hover {\n  color: #0e0a42 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
